import { FC } from 'react';
import styles from './index.module.less';
import cs from 'classnames';

/**
 * @Description 得分卡片（四维时使用）
 */
const ScoreCard: FC<{
  title?: string,
  score: number,
  totalScore?: number,
  lineColor?: string, // 进度条颜色
  lineBgColor?: string, // 进度条背景色
  isSemirModel?: boolean,
  hasBlank?: boolean,
  // describe = '-'
}> = ({
  title = '-',
  score,
  totalScore = 100,
  lineColor = '#89D4FF', // 进度条颜色
  lineBgColor = '#EEEEEE', // 进度条背景色
  isSemirModel = false,
  hasBlank = false,
  // describe = '-'
}) => {
  return (
    <div className={styles.scoreCard}>
      <div className={styles.titleCon}>
        <div className={cs(isSemirModel ? styles.nameCon : '')}>
          <span className={hasBlank ? 'pl-8' : ''}></span>{title}
        </div>
        <div className={styles.lineBg} style={{ backgroundColor: lineBgColor }}>
          <div className={styles.lineVal} style={{ width: `${totalScore || 0}%`, backgroundColor: lineColor }}></div>
        </div>
        <div className={styles.score}>
          {score}
        </div>
      </div>
      {/* <div className={styles.desc}>
        {describe}
      </div> */}
    </div>
  );
};

export default ScoreCard;
